import { toLower } from 'lodash';
import React from 'react';
import { FilterSelect } from './styles/LatestNewsPaginatedSelect.styled';

export default function LatestNewsPaginatedSelect({ dir, onChange, options, selected }) {
  const isArabic = dir === 'rtl';
  const [isOpen, setIsOpen] = React.useState(false);
  const list = options.map((option) => ({
    label: option,
    value: toLower(option),
  }));
  const currValue = list.find(({ label }) => label === selected);

  return (
    <FilterSelect
      isArabic={isArabic}
      classNamePrefix="dropdown"
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
      onChange={({ label }) => onChange(label)}
      isOpen={isOpen}
      placeholder={selected}
      options={list}
      value={currValue}
    />
  );
}
